import { Fragment, useEffect, useState } from "react"
import { Controller } from "react-hook-form"
import { useSelector } from "react-redux"
import { isEqual } from "lodash"
import dayjs from "dayjs"

export default function TypeSelect({ pending_applications, project, control, setStep, setPopup }) {

    const CMS = useSelector((state) => state.CMS)
    const { award: awardApplications, ...applications } = pending_applications
    const [ types, setTypes ] = useState(null)

    useEffect(() => {
        if (project) {
            handleTypeList(project)
        }
    }, [project])

    function handleTypeList(project) {
        const list = [
            {
                shortcut: 'join-exhibition',
                label: '參展證明',
                pending: applications['join-exhibition']
            },
            {
                shortcut: 'join-competition',
                label: '參賽證明',
                pending: applications['join-competition']
            },
            {
                shortcut: 'advisor',
                label: '指導老師證明',
                pending: applications['advisor']
            },
        ]
        if (project.awards?.length > 0) {
            const prelimAward = project.awards.find(a => a.award_type.shortcut === "prelim-nominee")
            const finalAward = project.awards.find(a => a.award_type.shortcut === "final-nominee")
            // if (!prelimAward) {
            //     list.unshift({
            //         shortcut: 'join-exhibition',
            //         label: '參展證明',
            //         pending: applications['join-exhibition']
            //     })
            // }
            if (prelimAward) {
                const awardInfo = Object.assign(JSON.parse(JSON.stringify(prelimAward)), {
                    shortcut: 'prelim-nominee',
                    label: '複選入圍證明',
                    pending: applications['prelim-nominee']
                })
                list.push(awardInfo)
            }
            if (finalAward) {
                const awardInfo = Object.assign(JSON.parse(JSON.stringify(finalAward)), {
                    shortcut: 'final-nominee',
                    label: '決選入圍證明',
                    pending: applications['final-nominee']
                })
                list.push(awardInfo)
            }
            // project.awards.map((award) => {
            project.awards.filter((a) => !['prelim-nominee', 'final-nominee'].includes(a.award_type.shortcut))?.map((award) => {
                const awardInfo = Object.assign(JSON.parse(JSON.stringify(award)), {
                    shortcut: 'award',
                    label: award.award_type.name,
                    pending: awardApplications[award.award_type.shortcut]
                })
                list.push(awardInfo)
            })
        }
        setTypes(list)
    }

    return (
        <Fragment>
            <div className="text-[1.5rem] font-semibold mb-2">
                證明文件／獎狀申請
            </div>
            <div className="text-[0.875rem] text-black-700 font-light mb-6">
                請選擇欲申請的文件類型，確認資料後將寄至指定信箱。不同文件屬於不同流程，須個別送出申請。
            </div>
            { !types?.find((a) => a.pending)
                ?
                <Fragment>
                    <div className="text-[1.125rem] font-semibold mb-2">
                        目前沒有進行中的申請
                    </div>
                    <div className="text-[0.875rem] text-black-700 font-light mb-6">
                        通常性證明文件預計於 24 小時內寄出。如有申請資料變更或者申請「參展證明」者，需經人工審核，可能需要 3-10 天時間。如有疑問請聯繫服務信箱 <a className="underline" href={`mailto:${CMS.registries['cms.home.footer.email']}}`}>{CMS.registries['cms.home.footer.email']}</a>
                    </div>
                </Fragment>
                :
                <Fragment>
                    <div className="text-[1.125rem] font-semibold mb-2">
                        進行中的申請
                    </div>
                    <div className="text-[0.875rem] text-black-700 font-light mb-6">
                        通常性證明文件預計於 24 小時內寄出。如有申請資料變更或者申請「參展證明」者，需經人工審核，可能需要 3-10 天時間。如有疑問請聯繫服務信箱 <a className="underline" href={`mailto:${CMS.registries['cms.home.footer.email']}}`}>{CMS.registries['cms.home.footer.email']}</a>
                    </div>
                    <ul className="list-disc mb-6">
                        { types?.filter((a) => a.pending)?.map((application, index) => (
                            // console.log('application', application),
                            <li key={`application-${index}`} className="pb-2">
                                <span className="font-light">
                                    {application.shortcut === 'award' && '獲獎證明：'}
                                    {application.label}
                                </span>
                                <br />
                                <span className="text-main-600 font-light">
                                    （於 {dayjs(application.pending.create_time).format('YYYY/MM/DD HH:mm')} 送出）
                                </span>
                            </li>
                        ))}
                    </ul>
                </Fragment>
            }
            { types?.find((a) => !a.pending) &&
                <Fragment>
                    <div className="text-[1.125rem] font-semibold mb-4">
                        可申請項目：
                    </div>
                    <Controller
                        control={control}
                        name="certificate_type"
                        rules={{required: true}}
                        render={({ field }) => (
                            // console.log('field', field), 
                            <Fragment>
                                <div className="input-group mb-9">
                                    { types?.filter((a) => !a.pending)?.map((item, index) => (
                                        // console.log('item', item),
                                        <label
                                            key={`item-${index}`}
                                            className="!flex items-center gap-1.5"
                                        >
                                            <input
                                                type="radio"
                                                name="certificate-type"
                                                onChange={(e) => {
                                                    field.onChange(item)
                                                }}
                                                checked={isEqual(field.value, item)}
                                            />
                                            <span className="font-light">
                                                {item.shortcut === 'award' && '獲獎證明：'}
                                                {item.label}
                                            </span>
                                        </label>
                                    ))}
                                </div>
                                <button
                                    type="button"
                                    className="w-full btn-black btn-round mb-3"
                                    onClick={() => { setStep('info') }}
                                    disabled={!field.value}
                                >下一步</button>
                            </Fragment>
                        )}
                    />
                </Fragment>
            }
            <button
                type="button"
                className="w-full btn-outline-black btn-round"
                onClick={() => { setPopup(null) }}
            >返回</button>
        </Fragment>
    )
}